import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import dayjs from 'dayjs';
import {
    Button,
  Calendar,
  Modal,
  Select,
  Spin,
  Table,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faMapMarked } from '@fortawesome/pro-duotone-svg-icons';
import MainPage from '../../shared-components/main-page/MainPage';
import { H1 } from '../../shared-components/typography/Title';
import api from '../../../api/api';
import { notificationsAtom, viewLeadAtom, reloadLeadsAtom } from '../../../atoms/Atoms';
import { mapAppointmentStatus, toFormattedLocalDate, toFormattedLocalHour, toFormattedLocalTime, toLocalTime } from '../../../functions';
import { appointmentFilters } from '../../../utils';
import 'react-horizontal-scrolling-menu/dist/styles.css';

function Installations() {
  const visibilityApiRef = useRef(null);
  const { orgReferralCode } = useParams();
  const history = useHistory();
  const { Option } = Select;
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState({
    start: dayjs().startOf('month'),
    end: dayjs().endOf('month')
  });
  const [viewLead, setViewLead] = useRecoilState(viewLeadAtom);
  const [reloadLeads, setReloadLeads] = useRecoilState(reloadLeadsAtom);
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const [selectedDate, setSelectedDate] = useState(null);
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingInstallations, setLoadingInstallations] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(1);
  const [selectedDateInstallations, setSelectedDateInstallations] = useState([]);
  const [organization, setOrganization] = useState(null);
  const [loadingOrganization, setLoadingOrganization] = useState(false);
  const [loadingPendingInstallations, setLoadingPendingInstallations] = useState(false);
  const [pendingInstallations, setPendingInstallations] = useState([]);
  const [selectedPendingInstallation, setSelectedPendingInstallation] = useState(null);

  function getDayInstallations(date) {
    const startDate = date.startOf('day');
    const endDate = date.endOf('day');
    const dayInstallations = _.filter(leads, (a) => (dayjs(a.installationDateScheduled).isSame(startDate) || dayjs(a.installationDateScheduled).isAfter(startDate)) && (dayjs(a.installationDateScheduled).isSame(startDate) || dayjs(a.installationDateScheduled).isBefore(endDate)));
    setSelectedDateInstallations(dayInstallations);
  }

  function getPendingInstallations() {
    setLoadingPendingInstallations(true);
    api.get(`leads/pending/installations?orgReferralCode=${orgReferralCode ?? ''}`)
      .then((response) => {
        setLoadingPendingInstallations(false);
        if (response.data.success) {
          setPendingInstallations(response.data.data);
        } else {
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: response?.data?.error,
              error: true,
            },
          ]);
        }
      })
      .catch((error) => {
        setLoadingPendingInstallations(false);
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: error?.message,
            error: true,
          },
        ]);
      });
  }

  function getData(start, end, dateToSelect) {
    setDateRange({
      start,
      end
    });
    const startString = start.format('YYYY-MM-DDTHH:mm:ss');
    const endString = end.format('YYYY-MM-DDTHH:mm:ss');
    setLoading(true);
    api.get(`leads/installations?startDate=${startString}&endDate=${endString}&filter=${selectedFilter}&orgReferralCode=${orgReferralCode ?? ''}`)
    .then((response) => {
      setLoading(false);
      if (response.data.success) {
        setLeads(response.data.data);
        // if (dateToSelect) {
        //   const startDate = dateToSelect.startOf('day');
        //   const endDate = dateToSelect.endOf('day');
        //   const dayAppointments = _.filter(appointments, (a) => dayjs(a.installationDateScheduled) >= startDate && dayjs(a.installationDateScheduled) <= endDate);
        //   if (dayAppointments.length > 0) {
        //     setTimeout(() => {
        //       getDayAppointments(dateToSelect);
        //       setSelectedDate(dateToSelect);
        //     }, 500);
        //   }
        // }
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response?.data?.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setLoading(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error?.message,
          error: true,
        },
      ]);
    });
  }

  function getOrganization() {
    setLoadingOrganization(true);
    api.get(`organizations?rc=${orgReferralCode}`)
      .then((response) => {
        setLoadingOrganization(false);
        if (response?.data?.success) {
          if (response.data.data) {
            setOrganization(response.data.data);
            getData(dateRange.start, dateRange.end);
          } else {
            setNotifications([
              ...notifications,
              {
                title: t('error'),
                description: t('organization_was_not_found'),
                error: true,
              },
            ]);
            history.push('/admin');                
          }
        } else {
          setOrganization(null);
          setNotifications([
            ...notifications,
            {
              title: t('error'),
              description: t('organization_was_not_found'),
              error: true,
            },
          ]);
          history.push('/admin');
        }
      })
      .catch((error) => {
        setLoadingOrganization(false);
        history.push('/admin');
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: t('organization_was_not_found'),
            error: true,
          },
        ]);
      });
  }

  useEffect(() => {
    if (reloadLeads) {
      setReloadLeads(false);
      getData(dateRange.start, dateRange.end);
      getPendingInstallations();
    }
  }, [reloadLeads]);

  useEffect(() => {
    if (!viewLead) {
      getData(dateRange.start, dateRange.end, selectedDate);
      getPendingInstallations();
    }
  }, [viewLead]);

  useEffect(() => {
    if (!selectedPendingInstallation) {
      getPendingInstallations();
    }
  }, [selectedPendingInstallation]);

  useEffect(() => {
    getData(dateRange.start, dateRange.end);
  }, [selectedFilter]);

  useEffect(() => {
    getData(dateRange.start, dateRange.end);
    getPendingInstallations();
  }, []);

  useEffect(() => {
    if (orgReferralCode) {
      getOrganization();
    } else {
      getData(dateRange.start, dateRange.end);
    }
    getPendingInstallations();
  }, [orgReferralCode]);

  useEffect(() => {
    if (selectedDate) {
      getDayInstallations(selectedDate);
    } else {
      setSelectedDateInstallations([]);
    }
  }, [selectedDate]);

  return (
    <div>
      <Spin spinning={loadingPendingInstallations}>
        {pendingInstallations.length > 0 && (
          <div className="my-4">
            <ScrollMenu
              apiRef={visibilityApiRef}
              RightArrow={(
                <button
                  type="button"
                  className="mx-2 text-2xl disabled:text-gray-400"
                  disabled={visibilityApiRef?.current?.isLastItemVisible}
                  onClick={() => {
                    visibilityApiRef.current.scrollNext();
                  }}
                >
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
              )}
              LeftArrow={(
                <button
                  type="button"
                  className="mx-2 text-2xl disabled:text-gray-400"
                  disabled={visibilityApiRef?.current?.isFirstItemVisible}
                  onClick={() => {
                    visibilityApiRef.current.scrollPrev();
                  }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </button>
              )}
              Header={<p className="font-bold text-lg">{t('pending_installations')}</p>}
            >
              {_.map(pendingInstallations, (install) => (
                <div className="mx-2" itemID={install.id}>
                  <button
                    type="button"
                    className="p-4 my-2 shadow-md bg-white w-52 h-auto md:h-52 md:w-min-52"
                    onClick={() => setSelectedPendingInstallation(install)}
                  >
                    <p className="line-clamp-1">{install?.submittedBy.completeName}</p>
                    <p className="font-bold">{toFormattedLocalTime(install?.installationDateScheduled)}</p>
                    {install?.externalDealId && (
                      <p>{install?.externalDealId}</p>
                    )}
                    {(selectedFilter === 0 || selectedFilter === 3) && (
                      <div className="italic text-xs">
                        {t(mapAppointmentStatus(install?.appointmentStatus))}
                      </div>
                    )}
                    {(install?.addressLine1 || install?.addressLine2) && (
                      <div className="mt-4 hidden md:block">
                        {install?.addressLine1 && (
                          <p className="line-clamp-1">{install?.addressLine1}</p>
                        )}
                        {!install?.addressLine1 && (
                          <p className="opacity-0">.</p>
                        )}
                        {install?.addressLine2 && (
                          <p className="line-clamp-1">{install?.addressLine2}</p>
                        )}
                        {!install?.addressLine2 && (
                          <p className="opacity-0">.</p>
                        )}
                      </div>
                    )}
                  </button>
                </div>
              ))}
            </ScrollMenu>
          </div>
        )}
        {pendingInstallations.length === 0 && (
          <div className={loadingPendingInstallations ? 'h-12 md:h-0' : ''} />
        )}
      </Spin>
      <Spin spinning={loadingOrganization}>
        <div className="md:flex my-4 items-center space-y-2">
          {/* <H1 text={organization ? `${organization?.nameEn} - ${t('appointments')}` : t('global_appointments')} /> */}
          {/* <Select
            className="w-full md:w-48 ml-auto"
            value={selectedFilter}
            disabled={loading}
            onChange={(obj) => setSelectedFilter(obj)}
          >
            {_.map(appointmentFilters, (f) => (
              <Option value={f.id}>{t(f.name)}</Option>
            ))}
          </Select> */}
          <Button
            type="primary"
            size="small"
            loading={loading}
            className="md:ml-auto w-full md:w-auto"
            onClick={() => getData(dateRange.start, dateRange.end)}
          >
            {t('reload')}
          </Button>
        </div>
        <Spin spinning={loading}>
          <Calendar
            mode="month"
            showWeek
            loading
            yearControlWidth="0"
            monthControlWidth="0"
            onPanelChange={(value, mode) => {
              setDateRange({
                start: value.startOf('month'),
                end: value.endOf('month')
              });
            }}
            onSelect={(date, selectInfo) => {
              if (selectInfo.source === 'date') {
                setSelectedDate(date);
              } else {
                getData(date.startOf('month'), date.endOf('month'), date);
                getPendingInstallations();
              }
            }}
            cellRender={(date, info) => {
              const startDate = date.startOf('day');
              const endDate = date.endOf('day');
              const dayInstallations = _.filter(leads, (a) => (dayjs(a.installationDateScheduled).isSame(startDate) || dayjs(a.installationDateScheduled).isAfter(startDate)) && (dayjs(a.installationDateScheduled).isSame(startDate) || dayjs(a.installationDateScheduled).isBefore(endDate)));
              const isPast = dayjs() > date;
              return (
                <>
                  <div className="hidden md:block tight-line-height">
                    {dayInstallations?.length > 1 && (
                      <div className={`rounded-full text-center text-xs items-center h-4 w-4 ${isPast ? 'bg-gray-400 text-white' : 'bg-green-400 text-white'}`}>
                        {dayInstallations?.length}
                      </div>
                    )}
                    {_.map(dayInstallations, (a) => (
                      <div className={`${isPast ? 'text-gray-400' : ''} border my-2 text-center justify-center`}>
                        {(!orgReferralCode && a.referredBy) && (
                          <p className="font-bold text-xs">{a?.referredBy?.nameEn}</p>
                        )}
                        {_.filter(a?.assignments, (as) => as.ownershipType === 0).length > 0 && (
                          <div className="mb-2">
                            <p className="font-bold">{t('closer')}:</p>
                            <p>{_.filter(a?.assignments, (as) => as.ownershipType === 0)[0].assignedTo?.completeName}</p>
                          </div>
                        )}

                        <p className="font-bold">{t('client')}:</p>
                        <p>{a.submittedBy.completeName}</p>
                        <p className="mt-1">{toFormattedLocalHour(a.installationDateScheduled)}</p>
                        {(selectedFilter === 0 || selectedFilter === 3) && (
                          <div className="italic text-xs">
                            {t(mapAppointmentStatus(a.appointmentStatus))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                  {dayInstallations?.length > 0 && (
                    <div className="md:hidden text-center items-center justify-items-center">
                      <div className={`rounded-full text-center items-center h-6 w-6 ${isPast ? 'bg-gray-400 text-white' : 'bg-green-400 text-white'}`}>
                        {dayInstallations?.length}
                      </div>
                    </div>
                  )}
                </>
              );
            }}
          />
        </Spin>
        <Modal
          open={selectedDate}
          footer={null}
          zIndex={997}
          onCancel={() => setSelectedDate(null)}
        >
          <strong>{toFormattedLocalDate(selectedDate)}</strong>
          <Table
            className="mt-2 w-full"
            loading={loading}
            dataSource={selectedDateInstallations}
            bordered
            size="small"
            columns={[
              {
                title: '',
                align: 'center',
                className: 'text-sm w-full',
                render: (row) => (
                  <div className="border border-xl b-2 p-4 border-blue-400 rounded-md">
                    <div className="items-center justify-center text-center mb-4">
                      <AddToCalendarButton
                        trigger="click"
                        name={`${row.submittedBy} - ${row.municipality}`}
                        options={['Outlook.com', 'Apple', 'Google', 'Yahoo', 'iCal']}
                        startDate={toLocalTime(row.installationDateScheduled).format('YYYY-MM-DD')}
                        startTime={toLocalTime(row.installationDateScheduled).format('HH:mm')}
                        endTime={toLocalTime(row.installationDateScheduled).add(1, 'hour').format('HH:mm')}
                        timeZone="America/Puerto_Rico"
                        location={`${row.addressLine1} ${row.addressLine2}`}
                      />
                    </div>
                    {(!orgReferralCode && row.referredBy) && (
                      <p className="font-bold">{row?.referredBy?.nameEn}</p>
                    )}
                    <div className="grid grid-cols-2">
                      {_.filter(row?.assignments, (as) => as.ownershipType === 0).length > 0 && (
                        <div className="mb-2">
                          <p className="font-bold">{t('closer')}:</p>
                          <p>{_.filter(row?.assignments, (as) => as.ownershipType === 0)[0].assignedTo?.completeName}</p>
                        </div>
                      )}
  
                      <div>
                        <p className="font-bold">{t('client')}:</p>
                        <p>{row.submittedBy.completeName}</p>
                      </div>
                    </div>
                    <p>{toFormattedLocalHour(row.installationDateScheduled)}</p>
                    {row.externalDealId && (
                      <p>{row.externalDealId}</p>
                    )}
                    {(selectedFilter === 0 || selectedFilter === 3) && (
                      <div className="italic text-xs">
                        {t(mapAppointmentStatus(row.appointmentStatus))}
                      </div>
                    )}
                    {(row.addressLine1 || row.addressLine2) && (
                      <div className="mt-4">
                        {row.addressLine1 && (
                          <p>{row.addressLine1}</p>
                        )}
                        {row.addressLine2 && (
                          <p>{row.addressLine2}</p>
                        )}
                      </div>
                    )}
                    {row.location?.lat !== 0 && row.location?.lon !== 0 && (
                      <div>
                        <a
                          href={`https://www.google.com/maps?q=${row.location.lat},${row.location.lon}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="ml-2 text-2xl"
                          aria-label={`View location on map for ${row?.municipality ?? 'this place'}`}
                        >
                          <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
                        </a>
                      </div>
                    )}
                    <Button
                      type="primary"
                      className="mt-6 w-full md:w-2/3"
                      loading={loadingInstallations}
                      onClick={() => setViewLead(row)}
                    >
                      {t('view')}
                    </Button>
                  </div>
                )
              }
            ]}
          />
        </Modal>
        <Modal
          open={selectedPendingInstallation}
          footer={null}
          zIndex={997}
          onCancel={() => setSelectedPendingInstallation(null)}
        >
          <div className="text-center">
            <div className="items-center justify-center text-center mb-4">
              <AddToCalendarButton
                trigger="click"
                name={`${selectedPendingInstallation?.submittedBy} - ${selectedPendingInstallation?.municipality}`}
                options={['Outlook.com', 'Apple', 'Google', 'Yahoo', 'iCal']}
                startDate={toLocalTime(selectedPendingInstallation?.installationDateScheduled).format('YYYY-MM-DD')}
                startTime={toLocalTime(selectedPendingInstallation?.installationDateScheduled).format('HH:mm')}
                endTime={toLocalTime(selectedPendingInstallation?.installationDateScheduled).add(1, 'hour').format('HH:mm')}
                timeZone="America/Puerto_Rico"
                location={`${selectedPendingInstallation?.addressLine1} ${selectedPendingInstallation?.addressLine2}`}
              />
            </div>
            <p>{selectedPendingInstallation?.submittedBy.completeName}</p>
            <p>{toFormattedLocalHour(selectedPendingInstallation?.installationDateScheduled)}</p>
            {selectedPendingInstallation?.externalDealId && (
              <p>{selectedPendingInstallation?.externalDealId}</p>
            )}
            {(selectedFilter === 0 || selectedFilter === 3) && (
              <div className="italic text-xs">
                {t(mapAppointmentStatus(selectedPendingInstallation?.appointmentStatus))}
              </div>
            )}
            {(selectedPendingInstallation?.addressLine1 || selectedPendingInstallation?.addressLine2) && (
              <div className="mt-4">
                {selectedPendingInstallation?.addressLine1 && (
                  <p>{selectedPendingInstallation?.addressLine1}</p>
                )}
                {selectedPendingInstallation?.addressLine2 && (
                  <p>{selectedPendingInstallation?.addressLine2}</p>
                )}
              </div>
            )}
            {selectedPendingInstallation?.location?.lat !== 0 && selectedPendingInstallation?.location?.lon !== 0 && (
              <div>
                <a
                  href={`https://www.google.com/maps?q=${selectedPendingInstallation?.location.lat},${selectedPendingInstallation?.location.lon}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 text-2xl"
                  aria-label={`View location on map for ${selectedPendingInstallation?.municipality ?? 'this place'}`}
                >
                  <FontAwesomeIcon icon={faMapMarked} className="text-primaryColor mr-2" />
                </a>
              </div>
            )}
            <Button
              type="primary"
              className="mt-6 w-full md:w-2/3"
              loading={loadingInstallations}
              onClick={() => setViewLead(selectedPendingInstallation)}
            >
              {t('view')}
            </Button>
          </div>
        </Modal>
      </Spin>
    </div>
  );
}

export default Installations;
